var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.751.75c-3.327 0-3.744.014-5.051.074-1.304.06-2.194.266-2.973.57a5.998 5.998 0 0 0-2.17 1.412 6.014 6.014 0 0 0-1.414 2.17c-.304.779-.51 1.669-.57 2.973C2.516 9.255 2.5 9.673 2.5 13s.015 3.743.074 5.05c.06 1.304.266 2.194.57 2.973.312.806.73 1.49 1.412 2.17a5.996 5.996 0 0 0 2.17 1.414c.779.303 1.67.51 2.973.569 1.307.06 1.724.074 5.05.074 3.328 0 3.744-.015 5.05-.074 1.305-.06 2.196-.266 2.975-.57a5.994 5.994 0 0 0 2.169-1.413 6.014 6.014 0 0 0 1.414-2.17c.3-.779.508-1.67.569-2.973.059-1.307.074-1.723.074-5.05s-.015-3.744-.074-5.051c-.061-1.304-.268-2.194-.57-2.973a6.012 6.012 0 0 0-1.413-2.17 5.987 5.987 0 0 0-2.17-1.413c-.78-.303-1.671-.51-2.975-.57C18.491.764 18.075.75 14.748.75h.003Zm-1.099 2.208h1.1c3.27 0 3.658.011 4.95.07 1.193.055 1.842.254 2.274.422.571.222.979.487 1.407.916.429.429.695.837.917 1.409.168.431.367 1.08.422 2.274.059 1.291.071 1.679.071 4.948 0 3.27-.012 3.657-.071 4.949-.055 1.194-.254 1.842-.422 2.274a3.788 3.788 0 0 1-.917 1.407 3.79 3.79 0 0 1-1.407.916c-.432.169-1.08.368-2.275.422-1.291.059-1.68.072-4.95.072-3.27 0-3.659-.013-4.95-.072-1.194-.055-1.843-.255-2.275-.422a3.794 3.794 0 0 1-1.408-.916 3.797 3.797 0 0 1-.917-1.408c-.168-.432-.368-1.08-.422-2.274-.059-1.292-.07-1.68-.07-4.95 0-3.272.011-3.658.07-4.95.055-1.194.254-1.842.422-2.274.222-.571.488-.98.917-1.409a3.802 3.802 0 0 1 1.408-.916c.432-.169 1.08-.368 2.275-.423 1.13-.05 1.568-.066 3.851-.069v.003Zm7.638 2.034a1.47 1.47 0 1 0 0 2.939 1.47 1.47 0 0 0 0-2.94Zm-6.539 1.717a6.291 6.291 0 1 0 0 12.582 6.291 6.291 0 0 0 0-12.582Zm0 2.208a4.083 4.083 0 1 1 0 8.166 4.083 4.083 0 0 1 0-8.166Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 27.648,
    height: 27.648,
    x: 0.926,
    y: 0.75,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    radius: 1.574,
    result: "effect1_dropShadow_108_1132"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.574
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.574
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0941176 0 0 0 0 0.152941 0 0 0 0 0.294118 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_108_1132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_108_1132",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.729f5ac6508dfa32fa83e60691ebe134.svg";
export { ForwardRef as ReactComponent };